<!-- /SectionTwo/ -->
<template>
    <div class="sectionSolutionContainer" id="solution">
      <h1 class="titleSolution">
        La solution Prexange
      </h1>
      
      <div class="bloksContainerSolution">
      <div class="blockSolution">
    
        <div class="blockTextSolution">
          <p class="text-center">
            Le projet PREXANGE est né d’une réflexion entre experts du courtage, de la banque et de l’ e-commerce. 
          </p>
          <p class="text-center">L’idée est de créer un dispositif qui permet de remettre le client au centre des transactions et de respecter les réglementations en vigueur. La rencontre de deux mondes pour en créer un troisième.</p>
          <p class="text-center">PREXANGE est une plateforme interconnectée permettant à tous les “acteurs” du crédit, depuis le client demandeur jusqu’aux collaborateurs bancaires, de se rencontrer sur une place de marché optimisée.</p>

        </div>
      </div>
    </div>
    
     </div>

  </template>
  
  <script>
  
  
  
  export default {
    name: 'solutionSection',
    components: {
    },
    data() {
      return {
        isSidebarOpen: false,
        settings: {
          "dots": true,
          "arrows": false,
          "dotsClass": "slick-dots ",
          "edgeFriction": 0.35,
          "infinite": false,
          "speed": 500,
          "slidesToShow": 1,
        },
        blocks: [
          {
            title: 'Les banques',
            icon: 'ic:round-signal-cellular-alt',
            text: 'Le renouvellement de la clientèle devient crucial face à la baisse de fréquentation des agences et à la concurrence des néo-banques. La nécessité de s\'adapter s\'impose, tant au niveau de l\'organisation que de la productivité, pour répondre aux exigences accrues des emprunteurs.'
          },
          {
            title: 'Les emprunteurs',
            icon: 'lucide:users',
            text: 'En quête de la meilleure offre, expriment un besoin constant de conseil et d\'accompagnement. La comparaison des offres du marché devient un élément essentiel dans leur processus de décision.'
          },
          {
            title: 'Les courtiers',
            icon: 'uil:code',
            text: 'Ils font face à la difficulté d\'accéder à certaines banques et à la responsabilité d\'aiguiller les dossiers dans le respect des intérêts des clients.'
          }
        ]
      };
    },
  };
  </script>
  
  
  <style lang="scss">
  @import './solution.scss'
  
  </style>